import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTeams } from "../../actions/homeActions";

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data: TheATeamData, isLoading, isError, error } = useTeams();
  const handleTeamId = (id, TheATeamColorsData) => {
    dispatch({
      type: "UPDATE_TEAM_DATA",
      payload: { teamData: TheATeamColorsData },
    });
    navigate(`/single-team/${id}`);
  };
  const settings = {
    dots: false,
    infinite: TheATeamData?.teams?.length > 4,
    slidesToShow:
      TheATeamData?.teams?.length >= 4 ? 4 : TheATeamData?.teams?.length,
    slidesToScroll: 1,
    autoplay: TheATeamData?.teams?.length > 4,
    speed: 3000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    pauseOnHover: true,
    variableWidth: TheATeamData?.teams?.length >= 4 ? false : true,
    arrows: false,
    className: TheATeamData?.teams?.length >= 4 ? "" : "sm:px-5 xl:px-10",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow:
            TheATeamData?.teams?.length >= 4 ? 4 : TheATeamData?.teams?.length,
          slidesToScroll: 1,
          cssEase: "linear",
          pauseOnHover: true,
          infinite: TheATeamData?.teams?.length > 4,
          autoplay: TheATeamData?.teams?.length > 4,
          centerMode: false,
          variableWidth: false,
          className: TheATeamData?.teams?.length >= 4 ? "" : "sm:px-5",
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow:
            TheATeamData?.teams?.length >= 2 ? 2 : TheATeamData?.teams?.length,
          slidesToScroll: 1,
          cssEase: "linear",
          pauseOnHover: true,
          infinite: TheATeamData?.teams?.length > 2,
          autoplay: TheATeamData?.teams?.length > 2,
          centerMode: false,
          variableWidth: false,
          className: TheATeamData?.teams?.length === 1 ? "xs:px-3" : "",
        },
      },
    ],
  };

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading teams: {error.message}</p>
      </div>
    );
  }
  return {
    isLoading,
    settings,
    TheATeamData,
    handleTeamId,
  };
};
